import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=22ecaed2"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
import style0 from "./Message.vue?vue&type=style&index=0&id=22ecaed2&prod&lang=scss"
import style1 from "./Message.vue?vue&type=style&index=1&id=22ecaed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports